<template>
  <section v-if="!customerTrackingLogs.length" class="skeleton-container">
    <skeleton-box v-if="showSkeleton" flat>
      <skeleton-line
        class="mb-4"
        size="md"
        :key="i"
        v-for="i in skeletonRows"
      />
    </skeleton-box>
    <v-layout v-else row align-center justify-center pt-4>
      <span>No se encontaron datos</span>
    </v-layout>
  </section>
  <vue-perfect-scrollbar v-else class="customer-tracking-logs">
    <section>
      <customer-tracking-log-item
        class="customer-tracking-logs__item"
        :customer-tracking-log="customerTrackingLog"
        :key="`customer-tracking-log-item-${index}`"
        v-for="(customerTrackingLog, index) in customerTrackingLogs"
      />
    </section>
  </vue-perfect-scrollbar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';
import SkeletonLine from '@/components/global/skeletons/Line';
import CustomerTrackingLogItem from './CustomerTrackingLogItem';

export default {
  components: {
    VuePerfectScrollbar,
    SkeletonBox,
    SkeletonLine,
    CustomerTrackingLogItem,
  },
  props: {
    showSkeleton: {
      type: Boolean,
      default: true,
    },
    skeletonRows: {
      type: Number,
      default: 7,
    },
    customerTrackingLogs: {
      type: Array,
      default: () => ([]),
    },
  },
};
</script>

<style scoped>
.customer-tracking-logs, .skeleton-container {
  height: 392px;
  padding: 20px;
}
.customer-tracking-logs__item {
  position: relative;
}
.customer-tracking-logs__item:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 16px;
  border-left: 1px solid #707070;
  height: 100%;
  top: 33px;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/CustomerTrackingLogs.vue